import type { ApplicationConfig, ApplicationRef, Type } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';

/**
 * Bootstraps the plugin as a custom element: {@link createApplication}, {@link createCustomElement},
 * then {@link customElements.define}.
 */
export function bootstrapPhoenixPluginCustomElement(
  rootComponent: Type<unknown>,
  tagName: string,
  config: ApplicationConfig,
): Promise<ApplicationRef | null> {
  return createApplication(config)
    .then((appRef) => {
      const elCtor = createCustomElement(rootComponent, { injector: appRef.injector });
      customElements.define(tagName, elCtor);
      return appRef;
    })
    // Root tsconfig has noImplicitReturns: .catch must explicitly return ApplicationRef | null
    // (same union as .then), and err must be typed — otherwise tsc reports TS7011 on the callback.
    .catch((err: unknown): ApplicationRef | null => {
      console.error(err);
      return null;
    });
}
